define("shared/components/shared/emoji-textarea", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/tracking", "@glimmer/component", "ember-concurrency", "ember-concurrency-decorators", "rsvp", "insert-text-at-cursor", "shared/utils/emoji-picker"], function (_exports, _component, _templateFactory, _object, _service, _tracking, _component2, _emberConcurrency, _emberConcurrencyDecorators, _rsvp, _insertTextAtCursor, _emojiPicker) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"@glimmer/component",0,"ember-concurrency",0,"ember-concurrency-decorators",0,"rsvp",0,"insert-text-at-cursor",0,"shared/utils/emoji-picker",0,"@ember/template-factory",1,"textarea-caret",1,"textcomplete"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="emojionearea {{if @class @class}}"
    {{did-insert (perform this.initialize)}}
  >
  
    <Textarea
      class="cPM--post__textarea e--modal__captionTextarea e--autosize qa--emoji_textarea"
      @disabled={{@isDisabled}}
      @name={{@name}}
      @placeholder={{@placeholder}}
      @value={{@value}}
      @focus-out={{this.focusOut}}
      @focus-in={{this.focusIn}}
      data-test-id="emoji textarea"
      {{autofocus @autofocus}}
      {{autoresize @value}}
      ...attributes
    />
  
    {{#if @getTextSuggestions.isRunning}}
      <div class="cTA--loading" style={{this.loadingStyle}}>{{t "shared_words.loading"}}</div>
    {{/if}}
  
    <div class="cPM--composerTool cPM--composerTool--emoji emojionearea-button-root" >
      <span
        class="cPM--composerTool__item emojionearea-button-trigger
        qa--fc_add_emoji {{if this.emojiAreaActive "is--active"}}"
        {{on "click" this.togglePicker}}
        data-test-id="emoji button"
      >
        {{svg-jar "emoji-smile" class="o--icon--sm"}}
        <span>{{t "post.body.emojis"}}</span>
      </span>
    </div>
  </div>
  
  */
  {
    "id": "2gFF8QH1",
    "block": "[[[11,0],[16,0,[29,[\"emojionearea \",[52,[30,1],[30,1]]]]],[4,[38,1],[[28,[37,2],[[30,0,[\"initialize\"]]],null]],null],[12],[1,\"\\n\\n  \"],[8,[39,3],[[24,0,\"cPM--post__textarea e--modal__captionTextarea e--autosize qa--emoji_textarea\"],[24,\"data-test-id\",\"emoji textarea\"],[17,2],[4,[38,4],[[30,7]],null],[4,[38,5],[[30,6]],null]],[[\"@disabled\",\"@name\",\"@placeholder\",\"@value\",\"@focus-out\",\"@focus-in\"],[[30,3],[30,4],[30,5],[30,6],[30,0,[\"focusOut\"]],[30,0,[\"focusIn\"]]]],null],[1,\"\\n\"],[41,[30,8,[\"isRunning\"]],[[[1,\"    \"],[10,0],[14,0,\"cTA--loading\"],[15,5,[30,0,[\"loadingStyle\"]]],[12],[1,[28,[35,6],[\"shared_words.loading\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"cPM--composerTool cPM--composerTool--emoji emojionearea-button-root\"],[12],[1,\"\\n    \"],[11,1],[16,0,[29,[\"cPM--composerTool__item emojionearea-button-trigger\\n      qa--fc_add_emoji \",[52,[30,0,[\"emojiAreaActive\"]],\"is--active\"]]]],[24,\"data-test-id\",\"emoji button\"],[4,[38,7],[\"click\",[30,0,[\"togglePicker\"]]],null],[12],[1,\"\\n      \"],[1,[28,[35,8],[\"emoji-smile\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,6],[\"post.body.emojis\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@class\",\"&attrs\",\"@isDisabled\",\"@name\",\"@placeholder\",\"@value\",\"@autofocus\",\"@getTextSuggestions\"],false,[\"if\",\"did-insert\",\"perform\",\"textarea\",\"autofocus\",\"autoresize\",\"t\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/emoji-textarea.hbs",
    "isStrictMode": false
  });
  /**
   * @module Components
   */


  /**
  * @class Shared::Emojitextarea
  * @extends Component
  *
  * This component adds the picmo emoji library to a standard textarea and
  * and takes care of inserting the text in the correct place. Picmo uses the
  * standard emoji set from the user's OS, so the emoji will look different on the
  * different browers. Picmo automatically selects the latest Emoji version that
  * is available for the user's OS.
  *
  * Required Arguments:
  *
  * - Value (String) text that gets added to the text area and returned when you save.
  *
  * Optional Arguments:
  *
  * Placeholder
  * - Class (String) CSS class declaration that gets added to the root component (wrapping div)
  * - Name (String) The name that you'd like to apply directly to the textfield. Makes it easier
      to reference later.
  * - match (Regex) Regex required for Textcomplete to recognize autocompletion queries
  * - getTextSuggestions (function(String): []) Array of search results for Textcomplete to display
  * - completeText (function(any): String) String for Textcomplete to replace query with
  *
  * Examples:
  *
  * Simple Usage:
  * ```
  * <Shared::EmojiTextarea
  *   @value={{this.comment}}
  *   @class={{cPT--post_textarea}}
  *   @name={{caption}}
  *   @placeholder={{Enter your note here}}
  * />
  * ```
  * Block Usage:
  *
  * Currently not supported!
  */
  let EmojiTextareaComponent = (_class = class EmojiTextareaComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "errors", _descriptor, this);

      _initializerDefineProperty(this, "locale", _descriptor2, this);

      _initializerDefineProperty(this, "caretX", _descriptor3, this);

      _initializerDefineProperty(this, "caretY", _descriptor4, this);

      _initializerDefineProperty(this, "picker", _descriptor5, this);

      _initializerDefineProperty(this, "showDropdown", _descriptor6, this);

      _initializerDefineProperty(this, "textarea", _descriptor7, this);

      _initializerDefineProperty(this, "textcomplete", _descriptor8, this);

      _initializerDefineProperty(this, "emojiAreaActive", _descriptor9, this);
    }

    /** CSS style for loading effect to track caret position
     *
     * @property loadingStyle
     * @type {String}
     */
    get loadingStyle() {
      return 'left: ' + this.caretX + 'px; top: ' + this.caretY + 'px ';
    }

    willDestroy() {
      var _this$textcomplete;

      super.willDestroy(...arguments);

      if (this.emojiAreaActive) {
        var _this$picker;

        (_this$picker = this.picker) === null || _this$picker === void 0 ? void 0 : _this$picker.close();
      }

      (_this$textcomplete = this.textcomplete) === null || _this$textcomplete === void 0 ? void 0 : _this$textcomplete.destroy();
    }

    *initialize(element) {
      try {
        this.textarea = element.querySelector('textarea');
        const rootElement = element.querySelector('.emojionearea-button-root');
        const triggerElement = element.querySelector('.emojionearea-button-trigger');
        this.picker = (0, _emojiPicker.default)({
          locale: this.locale,
          referenceElement: triggerElement,
          rootElement,
          triggerElement
        });
        this.picker.addEventListener('emoji:select', _ref2 => {
          let {
            emoji
          } = _ref2;
          (0, _insertTextAtCursor.default)(this.textarea, emoji);
        });
        this.picker.addEventListener('picker:close', () => {
          this.emojiAreaActive = this.picker.isOpen;
        });

        if (!this.args.match || !this.args.getTextSuggestions || !this.args.completeText) {
          return;
        }

        const {
          getCaretCoordinates,
          Textcomplete,
          Textarea
        } = yield this.loadDependencies.perform();

        if (Textcomplete && Textarea && getCaretCoordinates) {
          this.getCaretCoordinates = getCaretCoordinates;
          const editor = new Textarea(this.textarea);
          this.textcomplete = new Textcomplete(editor, {
            dropdown: {
              maxCount: 16,
              className: 'cTA--list dropdown-menu textcomplete-dropdown',
              height: 200
            }
          });

          this._addTextListener();
        }
      } catch (error) {
        this.errors.log(error);
      }
    }

    togglePicker() {
      if (!this.args.isDisabled) {
        var _this$picker2, _this$picker3;

        (_this$picker2 = this.picker) === null || _this$picker2 === void 0 ? void 0 : _this$picker2.toggle();
        this.emojiAreaActive = (_this$picker3 = this.picker) === null || _this$picker3 === void 0 ? void 0 : _this$picker3.isOpen;
      }
    }

    focusOut() {
      var _this$textcomplete2, _this$args$setErrorVi, _this$args;

      (_this$textcomplete2 = this.textcomplete) === null || _this$textcomplete2 === void 0 ? void 0 : _this$textcomplete2.dropdown.deactivate();
      this.showDropdown = false;
      (_this$args$setErrorVi = (_this$args = this.args).setErrorVisibility) === null || _this$args$setErrorVi === void 0 ? void 0 : _this$args$setErrorVi.call(_this$args, true);
    }

    focusIn() {
      this.showDropdown = true;
    }

    *loadDependencies() {
      let textareaCaretPromise;
      let textcompletePromise;

      try {
        textareaCaretPromise = emberAutoImportDynamic("textarea-caret");
      } catch (error) {
        this.errors.log("Could not import textarea caret. ".concat(error));
      }

      try {
        textcompletePromise = emberAutoImportDynamic("textcomplete");
      } catch (error) {
        this.errors.log("Could not import textcomplete. ".concat(error));
      }

      const settledPromises = yield (0, _rsvp.allSettled)([textareaCaretPromise, textcompletePromise]);

      const textareaCaretModule = this._parseSettledPromise(settledPromises[0]);

      const textcompleteModule = this._parseSettledPromise(settledPromises[1]);

      const getCaretCoordinates = textareaCaretModule === null || textareaCaretModule === void 0 ? void 0 : textareaCaretModule.default;
      const Textcomplete = textcompleteModule === null || textcompleteModule === void 0 ? void 0 : textcompleteModule.Textcomplete;
      const Textarea = textcompleteModule === null || textcompleteModule === void 0 ? void 0 : textcompleteModule.Textarea;
      return {
        getCaretCoordinates,
        Textcomplete,
        Textarea
      };
    }
    /**
     * Handles text autocomplete
     * Refer to https://github.com/yuku/textcomplete/blob/master/doc/api.md
     *
     * @method addTextListener
     */


    _addTextListener() {
      this._setCaretPosition();

      this._clearCache();

      this.textcomplete.register([{
        index: 1,
        match: this.args.match,
        search: (term, callback) => {
          this.textcomplete.dropdown.deactivate();

          if (!this.args.getTextSuggestions || this.args.getTextSuggestions.isRunning || !this.showDropdown) {
            callback([]);
            return;
          }

          this._setCaretPosition();

          this.args.getTextSuggestions.perform(term).then(userSuggestions => {
            if (!this.showDropdown) {
              callback([]);
            } else if (!this.isDestroyed) {
              callback(userSuggestions);
            }
          }).catch(error => {
            if (!(0, _emberConcurrency.didCancel)(error)) {
              this.errors.log(error, null, 'warning');
            }
          });
        },
        template: (value, term) => {
          const name = this._addBoldTemplate(term, value.name || value);

          if (value.screen_name) {
            const screenName = this._addBoldTemplate(term, value.screen_name);

            return "<span class=\"cTA--list__title\">".concat(name, "</span> <small class=\"cTA--list__count cTA--list__count--light\">@").concat(screenName, "</small>");
          } else if (value.img) {
            return "<span class=\"cTA--list__user\"><img class=\"cTA--list__userAvatar\" src=\"".concat(value.img, "\"></span> <span class=\"cTA--list__title\">").concat(name, "</span>");
          }

          return "<span class=\"cTA--list__title\">".concat(name, "</span> <small class=\"cTA--list__count cTA--list__count--light\">@").concat(name, "</small>");
        },
        replace: value => {
          if (this.args.completeText) {
            return this.args.completeText(value);
          }

          return value.name;
        }
      }]);
      this.textcomplete.on('rendered', () => {
        if (this.textcomplete.dropdown.items.length >= 1) {
          this.textcomplete.dropdown.items[0].activate();
        }
      });
    }

    _addBoldTemplate(query, result) {
      const queryLower = query.toLowerCase();
      const resultLower = result.toLowerCase();
      const startIndex = resultLower.indexOf(queryLower);

      if (startIndex === -1) {
        return result;
      }

      const match = result.substring(startIndex, startIndex + query.length);
      return result.replace(match, "<b>".concat(match, "</b>"));
    }

    _clearCache() {
      if (typeof this.args.clearCache === 'function') {
        this.args.clearCache();
      }
    }

    _setCaretPosition() {
      const offsetX = 10;
      const offsetY = 30;
      const caretPosition = this.getCaretCoordinates(this.textarea, this.textarea.selectionEnd);
      this.caretX = caretPosition.left + offsetX;
      this.caretY = caretPosition.top + caretPosition.height + offsetY;
    }

    _parseSettledPromise(_ref3) {
      let {
        state,
        value,
        reason
      } = _ref3;

      if (state === 'fulfilled') {
        return value ? value : false;
      } else if (state === 'rejected') {
        const {
          error
        } = reason;
        this.errors.log(error);
        return;
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "caretX", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "caretY", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "picker", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showDropdown", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "textarea", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "textcomplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "emojiAreaActive", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "initialize", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togglePicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusOut", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "focusOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusIn", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "focusIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadDependencies", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "loadDependencies"), _class.prototype)), _class);
  _exports.default = EmojiTextareaComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EmojiTextareaComponent);
});